import { IfPermission } from '@app/core/auth/authorization/components/IfPermission';
import { pushTo } from '@app/core/routing';
import { useOwnedStation } from '@app/core/stations/hooks/useOwnedStation';
import { useFragmentQuery } from '@app/modules/fragments/hooks/useFragment';
import { routeGenerator } from '@app/modules/fragments/routing/FragmentsRoutes';
import { useAvailableSocialExportPlatformsForStation } from '@app/modules/social-export/hooks/useAvailableSocialExportPlatformsForStation';
import { PublishPlatformMenu } from '@app/modules/social-export/publish';
import { fragmentsPermissions } from '@mi-front/api-clients';

export interface FragmentVideoEditionPublishMenuProps {
  /** Video editor edit id passed to the upload route for source preselection (`editId` query param). */
  editId: string;
  fragmentId: string;
  /**
   * When true, only a share icon opens the menu (used next to the “published on …” label on edit cards).
   */
  iconOnly?: boolean;
}

/**
 * "Publicar en" menu for a publishable edit: lists platforms and navigates to the upload screen
 * with this edit preselected. Hidden for shared stations (social publish is owner-only).
 */
export function FragmentVideoEditionPublishMenu({
  editId,
  fragmentId,
  iconOnly = false,
}: FragmentVideoEditionPublishMenuProps) {
  const fragmentQuery = useFragmentQuery(fragmentId);
  const fragment = fragmentQuery.data;
  const ownedStation = useOwnedStation(fragment?.stationId);
  const { platforms: availablePlatforms } = useAvailableSocialExportPlatformsForStation(
    fragment?.stationId,
  );

  if (!fragment || !ownedStation) {
    return null;
  }

  return (
    <IfPermission permission={fragmentsPermissions.Fragments_SocialPublish}>
      <PublishPlatformMenu
        platforms={availablePlatforms}
        iconOnly={iconOnly}
        onSelectPlatform={(platformId) => {
          pushTo(routeGenerator.upload(fragment, { id: platformId }, editId));
        }}
      />
    </IfPermission>
  );
}
